import React, { useState, useEffect } from 'react'
import _ from 'lodash'
import moment from 'moment-timezone'
import { connect } from 'react-redux'
import { Box, Typography } from '@material-ui/core'
import CloseIcon from '@material-ui/icons/Close'
import BreadCrumbs from '../../Components/Breadcrumbs'
import { OutlinedButton, Popup, TableOutline } from '../../elements'
import { forwardTo } from '../../utils/helper'
import { AppButton, DisplayMessage, Loader } from '../../Components'
import { tableHeadings, EVENT_TYPE, defaultSubType } from './constants'
import { eventService, programService, vppService } from '../../Services'
import { SORTORDER } from '../../utils/constants'
import Calendar from '../../elements/calendar'
import { useStyles } from './style'
import { timeZoneAbbrs } from '../../utils/momentTimezones'
import * as messageTypes from '../../utils/messageTypes'
import { EVENT_SUBTYPE } from '../System/constant'

moment.fn.zoneName = function () {
  const abbr = this.zoneAbbr()
  return timeZoneAbbrs[abbr] || abbr
}

function EventsView(props) {
  const classes = useStyles()
  const allEventsCode = 2
  const timeFormat = 'MMMM DD, YYYY hh:mm A zz'
  const [programDetails, setProgramDetails] = useState({})
  const [showPopup, setShowPopup] = useState(false)
  const [eventList, setEventList] = useState([])
  const [eventCalendarList, setEventCalendarList] = useState([])
  const [headings, setHeadings] = useState(tableHeadings(classes))
  const [tableCount, setTableCount] = useState(0)
  const [page, setPage] = useState(1)
  const [rowsPerPage, setRowsPerPage] = useState(10)
  const [sortBy, setSortBy] = useState('end_date_time')
  const [isAscending, setAscending] = useState(false)
  const [isCalendarView, setCalendarView] = useState(false)
  const [startDate, setStartDate] = useState(moment())
  const [fromDate, setFromDate] = useState(moment.tz(new Date(), props.timeZone).startOf('month').format('YYYY-MM-DD HH:mm:ssZ'))
  const [toDate, setToDate] = useState(moment.tz(new Date(), props.timeZone).add(3, 'M').endOf("month").format('YYYY-MM-DD HH:mm:ssZ'))
  const [open, setOpen] = useState(false)
  const [message, setMessage] = useState('')
  const [messageType, setMessageType] = useState()
  const [loading, setLoading] = useState(false)
  const [eventCount, setEventCount] = useState({})

  useEffect(() => {
    const programId = _.get(props.match.params, 'programs_id', '')
    let details = {}
    programService.getProgramsById(props.accountId, programId)
      .then(response => {
        details = {
          programId,
          programName: _.get(response, 'program_name_admin_ui', ''),
          program: response || {},
          programIsActive: _.get(response, 'is_active', false)
        }
        vppService.getAllProgramVpp(props.accountId, programId)
          .then(response => {
            details.vppCount = response ? response.length : 0
          })
          .catch(() => { })
        setProgramDetails(details)
      })
      .catch(() => { })
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [props.accountId, props.match.params])

  useEffect(() => {
    if (props.accountId && programDetails && programDetails.programId) {
      getAllEvents(sortBy, rowsPerPage, page, isAscending)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [props.accountId, programDetails])

  const successCb = (response) => {
    const eventListData = []
    _.isArray(response) && response.forEach((obj) => {
      const { name, type, subtype, start_date_time, end_date_time, status, event_id, participating_systems } = obj
      const startTime = moment(_.get(obj, 'start_date_time', ''))
      const endTime = moment(_.get(obj, 'end_date_time', ''))
      const duration = moment.duration(endTime.diff(startTime))
      eventListData.push([
        {
          id: 'name',
          value: name || '',
          eventId: event_id || '',
          statusValue: status,
          className: classes.tableCell,
          handleClick: (selected) => {
            props.history.push({
              pathname: `/programs/${programDetails.programId || ''}/events/${selected.eventId}`
            })
          }
        },
        {
          id: 'type',
          value: EVENT_TYPE[type] || '',
          className: classes.tableCell,
        },
        {
          id: 'sub_type',
          value: !_.isNil(subtype) ? EVENT_SUBTYPE[subtype] || '' : defaultSubType[type] || <Box textAlign="center">{'-'}</Box>,
          className: classes.tableCell,
        },
        {
          id: 'start_date_time',
          value: start_date_time ? moment.tz(start_date_time, props.timeZone).format(timeFormat) : '',
          className: classes.tableCell,
        },
        {
          id: 'end_date_time',
          value: end_date_time ? moment.tz(end_date_time, props.timeZone).format(timeFormat) : '',
          className: classes.tableCell,
        },
        {
          id: 'eventDuration',
          value: _.get(obj, 'start_date_time', '') && _.get(obj, 'end_date_time', '') ? `${Math.floor(duration.asHours())} hour(s) ${moment.utc(duration.asMilliseconds()).format("mm")} minute(s)` : '-',
          className: classes.tableCell,
        },
        {
          id: 'systemsParticipated',
          value: participating_systems || 0,
          className: `${classes.tableCell} ${classes.systemsParticipated}`,
        }
      ])
    })

    setEventList(eventListData || [])
  }

  const getAllEvents = (sortByType, pageSize, pageNum, isAscendingFlag) => {
    setLoading(true)
    const programId = programDetails.programId || ''
    eventService.getAllEventsWithFilter({
      programId,
      accountId: props.accountId,
      eventSortBy: sortByType,
      eventPageNoAPI: pageNum - 1 < 0 ? 0 : pageNum - 1,
      eventPageSize: pageSize,
      eventTime: allEventsCode,
      eventSortAscendingOrder: isAscendingFlag
    })
      .then((response) => {
        const { vpp_event_list, total_count } = response
        successCb(vpp_event_list || [])
        setTableCount(total_count)
        setLoading(false)
      })
      .catch((error) => {
        setLoading(false)
        setOpen(true)
        setMessage(_.get(error, 'data.error.displayMessage', 'Something went wrong'))
        setMessageType(messageTypes.ERROR)
      })
  }

  const getAllCalendarEvents = async (date) => {
    setLoading(true)
    const programId = programDetails.programId || ''
    try {
      const response = await eventService.getAllEventsCalendarEvents({
        programId,
        accountId: props.accountId,
        startDate: moment.tz(date, 'MM-DD-YYYY', props.timeZone).startOf('day').format('YYYY-MM-DD HH:mm:ssZ'),
        endDate: moment.tz(date, 'MM-DD-YYYY', props.timeZone).endOf('day').format('YYYY-MM-DD HH:mm:ssZ')
      })
      setLoading(false)
      return response && _.isArray(response.vpp_event_list) ? response.vpp_event_list : []
    }
    catch (error) {
      setLoading(false)
      setOpen(true)
      setMessage(_.get(error, 'data.error.displayMessage', 'Something went wrong'))
      setMessageType(messageTypes.ERROR)
    }
  }

  const getAllCalendarEventsCount = () => {
    const programId = programDetails.programId || ''
    setLoading(true)
    eventService.getAllCalendarEventsCount({
      programId,
      accountId: props.accountId,
      startDate: fromDate,
      endDate: toDate
    })
      .then((response) => {
        setEventCount(response)
        setLoading(false)
      })
      .catch((error) => {
        setLoading(false)
        setOpen(true)
        setMessage(_.get(error, 'data.error.displayMessage', 'Something went wrong'))
        setMessageType(messageTypes.ERROR)
      })
  }

  const prevArrowPressed = () => {
    setStartDate(moment(startDate).subtract(1, 'M'))
    setFromDate(moment(startDate).subtract(1, 'M').startOf('month').format('YYYY-MM-DD HH:mm:ssZ'))
    setToDate(moment(startDate).subtract(1, 'M').add(3, 'M').endOf("month").format('YYYY-MM-DD HH:mm:ssZ'))
  }

  const nextArrowPressed = () => {
    setStartDate(moment(startDate).add(1, 'M'))
    setFromDate(moment(startDate).add(1, 'M').startOf('month').format('YYYY-MM-DD HH:mm:ssZ'))
    setToDate(moment(startDate).add(1, 'M').add(3, 'M').endOf("month").format('YYYY-MM-DD HH:mm:ssZ'))
  }

  const handleCreateNewEvent = () => {
    if (programDetails && programDetails.vppCount && programDetails.programId) {
      forwardTo(`/programs/${programDetails.programId}/create-new-event`)
    } else {
      setShowPopup(true)
    }
  }

  const handlePageChange = (newPage) => {
    setPage(newPage)
    getAllEvents(sortBy, rowsPerPage, newPage, isAscending)
  }

  const handleChangeRowsPerPage = (value) => {
    setRowsPerPage(value)
    setPage(1)
    getAllEvents(sortBy, value, 1, isAscending)
  }

  const handleSortData = (sortedObj) => {
    const modifiedObj = _.cloneDeep(headings)
    modifiedObj.forEach((obj, index) => {
      if (obj.id === sortedObj.id && obj.isSortable) {
        modifiedObj[index].sortOrder = obj.sortOrder === SORTORDER.ASC ? SORTORDER.DESC : SORTORDER.ASC
      } else {
        modifiedObj[index].sortOrder = SORTORDER.ASC
      }
    })
    const selectedObj = modifiedObj.find(obj => sortedObj.id === obj.id)
    const selectedTypeAsc = selectedObj.sortOrder === SORTORDER.ASC ? true : false
    setAscending(selectedTypeAsc)
    setPage(1)
    setSortBy(sortedObj.id)
    getAllEvents(selectedObj.id, rowsPerPage, 1, selectedTypeAsc)
    setHeadings(modifiedObj)
  }

  const renderNavValues = () => {
    const obj = {}
    obj[_.get(programDetails, 'programName', '')] = `/programs/${_.get(programDetails, 'programId', '')}`
    obj.state = {
      program: _.get(programDetails, 'program', '')
    }
    return [{ 'Home': '/' }, { 'Programs': '/programs' }, obj, { 'Events': '' }]
  }

  const renderPopupContent = () => {
    return (
      <Box className={classes.popWrapper}>
        <Typography className={classes.popText}>You need an VPP to create a event. Please create a new VPP.</Typography>
        <AppButton text='Ok' className={classes.ackButton} onClick={() => setShowPopup(false)} />
      </Box>
    )
  }

  const handleCalendarClose = () => {
    setCalendarView(false)
    getAllEvents(sortBy, rowsPerPage, page, isAscending)
  }

  const renderCalendarView = () => {
    return (
      <Box className={classes.calendarPopupContainer}>
        <Box className={classes.calendarHeader}>
          <Typography className={classes.popupHeader}>Events {programDetails.programName ? `in ${programDetails.programName}` : ''}</Typography>
          <span onClick={handleCalendarClose} className={classes.pointer}><CloseIcon style={{ color: '#545456' }} /></span>
        </Box>
        <div className={classes.calendarContainer}>
          <Calendar
            view={4}
            timeZone={props.timeZone}
            eventCount={eventCount}
            getEvents={getAllCalendarEvents}
            EventsList={eventCalendarList}
            programId={programDetails.programId}
            onPrevious={prevArrowPressed}
            onNext={nextArrowPressed}
          />
        </div>
      </Box>
    )
  }

  const handleCalendarClick = () => {
    setCalendarView(true)
    getAllCalendarEventsCount()
  }

  useEffect(() => {
    if (isCalendarView) {
      getAllCalendarEventsCount()
    }
  }, [fromDate, toDate])

  return (
    <Box>
      <BreadCrumbs value={renderNavValues()} />
      <DisplayMessage open={open} message={message} messageType={messageType} handleClose={() => setOpen(false)} />
      <Box className={classes.headerWrapper}>
        <Typography className={classes.title}>Events</Typography>
        <Box className={classes.headerButtonGroup}>
          <OutlinedButton label="view events on calendar" classes={classes.staticMargin} onClick={handleCalendarClick} />
          {!props.isViewOnly && programDetails && programDetails.programIsActive && <OutlinedButton label="create new event" classes={classes.staticMargin} onClick={handleCreateNewEvent} />}
        </Box>
      </Box>
      <Box className={classes.tableWrapper}>
        <TableOutline
          tableHeadings={headings}
          tableData={eventList}
          totalElement={tableCount}
          page={page}
          rowsPerPage={rowsPerPage}
          handleChangePage={handlePageChange}
          handleChangeRowsPerPage={handleChangeRowsPerPage}
          handleSortData={handleSortData}
          pagination
          loading={loading}
        />
      </Box>
      <Popup
        open={showPopup}
        handleClose={() => setShowPopup(false)}
        content={renderPopupContent()}
      />
      <Popup
        open={isCalendarView}
        handleClose={() => setCalendarView(false)}
        content={renderCalendarView()}
        className={classes.popupWrapper}
      />
      <Loader loading={loading} />
    </Box>
  )
}

const mapStateToProps = ({ auth }) => {
  const { accountId, timeZone, isViewOnly } = auth
  return { accountId, timeZone, isViewOnly }
}

export default connect(mapStateToProps, {})(EventsView)